module.exports = __webpack_public_path__ + "static/media/isb-logo.7c4d7957.png";